import React from "react";

// Layout Types
import RestaurantLayout from "./layouts/RestaurantLayout";

// Route Views
import Dashboard from "./views/dashboard/RestaurantDashboard";
import RestaurantFoodSelection from "./views/food_selection/RestaurantFoodSelection";
import OrderSummary from "./views/food_summary/OrderSummary";
import CurrentOrders from "./views/current_order/CurrentOrders";
import OrderDetail from "./views/current_order/OrderDetail";
import PastOrders from "./views/past_order/PastOrders";
import PaymentSuccessPage from "./views/PaymentSuccess";
import PaymentSuccessEnhanced from "./views/PaymentSuccessEnhanced";
import ContactUs from "./views/contact_us/ContactUs";
import Faq from "./views/faq/Faq";
import LoginPage from "./views/LoginPage";
import { ROUTE_PREFIX } from "./config";
import RestaurantFoodSelectionReadOnly from "./views/food_selection/RestaurantFoodSelectionReadOnly";
import InitialPage from "./views/InitialPage";
import InactiveTableView from "./views/InactiveTableView";

// const restaurantSlug = ":restaurantName"; // Uncomment this after testing
const restaurantSlug = `${ROUTE_PREFIX}:restaurantName`; //Temp for testing in client test server

export default [
  {
    path: `/${restaurantSlug}`,
    layout: RestaurantLayout,
    exact: true,
    component: () => <InitialPage />,
  },
  {
    path: `/${restaurantSlug}/login`,
    layout: RestaurantLayout,
    exact: true,
    component: () => <LoginPage />,
  },
  {
    path: `/${restaurantSlug}/home`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <Dashboard />,
  },
  {
    path: `/${restaurantSlug}/food-selection`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <RestaurantFoodSelection />,
  },
  {
    path: `/${restaurantSlug}/menu`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <RestaurantFoodSelectionReadOnly />,
  },
  {
    path: `/${restaurantSlug}/order-summary`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <OrderSummary />,
  },
  {
    path: `/${restaurantSlug}/current-orders`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <CurrentOrders />,
  },
  {
    path: `/${restaurantSlug}/orders/:id`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <OrderDetail />,
  },
  {
    path: `/${restaurantSlug}/past-orders`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <PastOrders />,
  },
  {
    path: `/${restaurantSlug}/payment-success`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <PaymentSuccessEnhanced />,
  },
  {
    path: `/${restaurantSlug}/payment-success-enhanced`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <PaymentSuccessEnhanced />,
  },
  {
    path: `/${restaurantSlug}/contact-us`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <ContactUs />,
  },
  {
    path: `/${restaurantSlug}/faq`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <Faq />,
  },
  {
    path: `/${restaurantSlug}/restaurant-config`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <Faq />,
  },
  {
    path: `/${restaurantSlug}/web-kot`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <Faq />,
  },
  {
    path: `/${restaurantSlug}/table-inactive`,
    exact: true,
    layout: RestaurantLayout,
    component: () => <InactiveTableView />,
  },
];
